
// from details.js
angular.module('olivioConfiguratorApp')
  .directive('detailssideview', function (Model) {
    return {
      restrict: 'A',
      link: function (scope, element) {
        var size = element.width();
        var draw = SVG(element.attr('id')).size(element.width(), element.height());
        var viewBoxWidthSide = 3980 * ((element.width()) / element.height());
        draw.viewbox(0, 0, viewBoxWidthSide, 3980 + 110);

        var pole = new OLIVIO.PoleSide(draw, null, null);
        pole.updateHeight();
        pole.updateLumsForceRotation();
        pole.repaint();


        scope.$watch('ready', function () {

          console.log("detailssideview WATCH ready");
          OLIVIO.cmodel.setLumTypes(scope.model.design.individualHeads, Model.goboAllowed() ? scope.model.gobo.individual : []);
          OLIVIO.cmodel.updateAll();

          scope.$watch('model.design.individualHeads', function (newValue, oldValue) {
            if (newValue) {
              console.log('detailssideview WATCH model.design.individualHeads');
              OLIVIO.cmodel.setLumTypes(scope.model.design.individualHeads, Model.goboAllowed() ? scope.model.gobo.individual : []);

              pole.updateLumsForceRotation();
            }
          }, true);
          scope.$watch('model.gobo.individual', function (newValue, oldValue) {
            if (newValue) {
              console.log('detailssideview WATCH model.gobo.individual');
              OLIVIO.cmodel.setLumTypes(scope.model.design.individualHeads, Model.goboAllowed() ? scope.model.gobo.individual : []);

              pole.updateLumsForceRotation();
            }
          }, true);
        });
      }
    };
  });


// from design.js

/*global $:false */

angular.module('olivioConfiguratorApp')
  .directive('sliderjs', function () {
    return {
      restrict: 'A',
      link: function (scope, element, attrs) {
        scope.$watch('ready', function () {
          var setup = scope.$eval(attrs.setup);
          $(element).slidesjs(setup);
          // give the setup object a reference to the goto function of the slider
          setup.goto = function (number) {
            //console.log('goto '+attrs.setup+':', number);
            $(element).slidesjs('goto', number);
          };
        });
      }
    };

  });


angular.module('olivioConfiguratorApp')
  .directive('onKeyup', function () {
    return function (scope, elm, attrs) {
      function applyKeyup() {
        scope.$apply(attrs.onKeyup);
      }

      var allowedKeys = scope.$eval(attrs.keys);
      elm.bind('keyup', function (evt) {
        //if no key restriction specified, always fire
        if (!allowedKeys || allowedKeys.length === 0) {
          applyKeyup();
        } else {
          angular.forEach(allowedKeys, function (key) {
            if (key === evt.which) {
              applyKeyup();
            }
          });
        }
      });
    };
  });

angular.module('olivioConfiguratorApp')
  .directive('nnTouchstart', function () {
    return function (scope, element, attrs) {
      element.bind('touchstart', function () {
        scope.$apply(attrs.nnTouchstart);
      });
    };
  });


angular.module('olivioConfiguratorApp')
  .directive('colorwheel', function () {
    return {
      restrict: 'A',
      link: function (scope, element, attrs) {

        scope.$watch('ready', function () {
          var radius = 17;
          var size = element.width();
          var margin = size * 0.2;
          //$(element).css('background-image','none');
          var draw = SVG(element.attr('id')).size(size, size);

          scope.$watch('model.design.colorIds', function (newValue, oldValue) {
            if (newValue) {
              $(element).css('background-image', 'none');
              draw.clear();
              if (scope.model.product.id === OLIVIO.PRODUCT_FLORACION) {
                //top
                draw.circle(radius).move((size * 0.5) - (radius * 0.5), margin * 1.17).fill({ color: scope.data.getColorSelectOption(scope.model.design.colorIds.mast).color, opacity: 0.7});
                //left
                draw.circle(radius).move(margin, size - margin - (radius)).fill({ color: scope.data.getColorSelectOption(scope.model.design.colorIds.lumiere).color, opacity: 0.7});
                //right
                draw.circle(radius).move(size - margin - (radius), size - margin - (radius)).fill({ color: scope.data.getColorSelectOption(scope.model.design.colorIds.inlay).color, opacity: 0.7});
              } else {
                //top
                draw.circle(radius).move((size * 0.5) - (radius * 0.5), (size * 0.5) - (radius * 0.5)).fill({ color: scope.data.getColorSelectOption(scope.model.design.colorIds.mast).color, opacity: 0.7});
              }
            }

          }, true);
        });
      }
    };
  });
